export default "__VITE_ASSET__RRKfg0kWmbuEATq25BsovA__"